import { useGilt } from 'providers/GILT.provider';

export const ReportsVATInput = ({ className, label, value, placeholder, onBlur, onChange }) => {
  const { isSalonWithVAT } = useGilt();

  if (!isSalonWithVAT) {
    return null;
  }

  return (
    <div className={className}>
      <div className="report-vat-lable">{label}</div>
      <input type="number" max="100" className="report-vat-input" placeholder={placeholder} value={value} onBlur={onBlur} onChange={onChange} autoComplete="off" />
    </div>
  );
};
